import { Microapp } from 'signup-constants/Microapp';
export const isMicroappValid = microapp => {
  return Object.values(Microapp).includes(microapp);
};